<template>
  <el-cascader
    ref="applicationRef"
    style="width: 100%"
    :value="value"
    :props="props"
    @change="change"
  ></el-cascader>
</template>

<script>
export default {
  name: 'ApplicationSelect',
  props: {
    value: {
      required: true,
    },
    placeholder: {
      type: String,
    },
  },
  data() {
    return {
      labels: [],
      props: {
        lazy: true,
        lazyLoad: async (node, resolve) => {
          let nodes = [];
          const { level, value, label } = node;
          if (level === 0) {
            const res = await this.$http.get(this.$API.product_list_get);
            if (res?.success) {
              nodes = res.data.map((item) => ({
                value: item.productLineCode,
                label: item.productLineName,
                leaf: false,
              }));
            }
          } else if (level === 1) {
            const res = await this.$http.get(this.$API.app_list_get, {
              params: {
                productLineCode: value,
              },
            });
            if (res?.success) {
              nodes = res.data.map((item) => ({
                value: item.applicationSign,
                label: item.applicationName,
                leaf: false,
              }));
            }
          } else if (level === 2) {
            const res = await this.$http.get(this.$API.application_list_get, {
              params: {
                applicationSign: value,
              },
            });
            if (res?.success) {
              nodes = res.data.map((item) => ({
                value: item.applicationInstSign,
                label: item.applicationInstName,
                leaf: true,
              }));
            }
          }
          resolve(nodes);
        },
      },
    };
  },
  mounted() {
    console.log(this.value);
  },
  methods: {
    change(val) {
      const checkNodes = this.$refs.applicationRef.getCheckedNodes();
      const pathLabels = checkNodes[0].pathLabels;
      this.$emit('input', val);
      this.$emit('update:label', pathLabels);
    },
  },
};
</script>
<style lang="scss" scoped>
.isCricle {
  ::v-deep .el-input__inner {
    border-radius: 16px;
  }
}
</style>
